// LIBRARIES //
import React from 'react';
import Styled from 'styled-components';

// COMPONENTS //
import Card from '../CardComponent'
import InviteResident from './InviteResident';
import ResidentDetails from './ResidentDetails';
import LeaseDetails from './LeaseDetails';
import AccountDetails from './AccountDetails';
import Notes from './Notes';

// HELPERS //
import { getTranslatedString } from 'helpers/i18n';

export const ResidentDetailsTabHeader = getTranslatedString('landlordPortal.tenantOverview.details');

// Why padding at the bottom? This works, margin doesn't ¯\_(ಠ_ಠ)_/¯
const StyledContainer = Styled.div`
  margin-top: 40px;
  margin-left: 32px;
  margin-right: 32px;
  padding-bottom: 56px;
`;

export const ResidentDetailsTab = ({ residentData, disabledProfilePicture, reloadPageData, toggleChatDrawer }) => {
  if (!residentData.id) return (<></>);

  const showInviteResident = (!residentData.invitation_accepted_at && !residentData.opted_out)

  return (
    <StyledContainer>
      {showInviteResident && <InviteResident residentData={residentData} reloadPageData={reloadPageData} />}
      <Card>
        <ResidentDetails disabledProfilePicture={disabledProfilePicture} residentData={residentData} toggleChatDrawer={toggleChatDrawer} />
        <LeaseDetails leaseData={residentData.lease} otherLeaseHolders={residentData.other_lease_holders} />
        <AccountDetails residentData={residentData} />
        <Notes leadId={residentData.lead_id} />
      </Card>
    </StyledContainer>
  )
}
